<div class="main-page consultas">
    <div class="container-fluid">
        <!-- LINHA TITULO + PESQUISA -->

        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])" data-title="Voltar"><i
                            class="fas fa-arrow-left"></i></a>
                    Consultar Motorista
                </h1>
            </div>
        </div>

        <div *ngIf="drivers?.data?.length === 0">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro at&eacute; o momento...</p>
            </div>
            <div class="row no-gutters mt-3">
                <a (click)="this.router.navigate(['/drivers/create'])" mat-button color="primary"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                    Criar um novo motorista
                </a>
            </div>
        </div>

        <div class="row no-gutters mt-3" *ngIf="drivers?.data?.length > 0">
            <div class="mat-elevation table-content">
<!--                 <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field>
                        <mat-label>Campo</mat-label>
                        <select matNativeControl [(ngModel)]="typeFilter">
                            <option *ngFor="let filtro of filtros" value={{filtro.campo}}>
                                {{filtro.valor}}
                            </option>
                        </select>
                    </mat-form-field>
                    <mat-form-field fxFlex="40%" class="ml-2">
                        <input autofocus type="text" matInput placeholder="Filtro" [(ngModel)]="filter" />
                    </mat-form-field>
                    <button type="button" mat-icon-button (click)="handleFilter()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div> -->
                <!-- (matSortChange)="handleSort($event)" -->
                
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%" class="ml-2">
                     <mat-label>Filtrar Por Nome</mat-label>
                     <input matInput autocomplete="off"
                     (keyup)="this.applyFilter($event)"  placeholder="Ex: joão" #input>
                   </mat-form-field>
                 </div>

                <table mat-table [dataSource]="drivers" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">{{ element.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nmNome">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Nome
                        </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            {{ element.nmNome }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cdSenha">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Senha
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.cdSenha }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nmempresa">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Matriz/Divisão/Filial
                        </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            {{ element.nmempresa }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cdCodigo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">{{ element.cdCodigo }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdNumeroRegistro">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Número Registro</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdNumeroRegistro }}</td>
                    </ng-container>

                    <ng-container matColumnDef="dtNascimento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nascimento</th>
                        <td mat-cell *matCellDef="let element">{{ element.dtNascimento }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdCpf">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            CPF
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.cdCpf }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cdRG">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            RG
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.cdRG }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nmOrgaoEmissor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Órgão Emissor
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nmOrgaoEmissor }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cdNumeroCnh">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Núm. CNH</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdNumeroCnh }}</td>
                    </ng-container>

                    <ng-container matColumnDef="dtValidadeCnh">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Val. CNH</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">{{ element.dtValidadeCnh | date: "dd/MM/yyyy"}}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdCategoriaCnh">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Categoria CNH</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">{{ element.cdCategoriaCnh }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nrTelefone">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Núm. Telefone</th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">{{ element.nrTelefone }}</td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            <span class="alerta mr-2" data-title="Editar"
                                *ngIf="this.permissionService.hasPermission('DRIVER_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Editar">
                                <a (click)="this.router.navigate(['/drivers/edit/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="clone">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            <span class="alerta mr-2" data-title="Duplicar"
                                *ngIf="this.permissionService.hasPermission('DRIVER_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Duplicar">
                                <a (click)="this.router.navigate(['/drivers/clone/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/duplic.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            <span class="alerta mr-2" data-title="Visualizar"
                                *ngIf="this.permissionService.hasPermission('DRIVER_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Visualizar">
                                <a (click)="this.router.navigate(['/drivers/view/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/view.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="(element.itemVencido) ? 'destacarVencido' : ''">
                            <button (click)="handleDelete(element.id)" class="btn btn-link"
                                *ngIf="this.permissionService.hasPermission('DRIVER_DELECAO_FUNCIONALIDADE', this.permissions)" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 20, 40, 100]" showFirstLastButtons></mat-paginator>

                 <!--   <mat-paginator *ngIf="drivers.data.length" [pageSize]="this.page.size" (page)="handlePageChanged($event)"
                    [length]="this.page.totalElements" showFirstLastButtons></mat-paginator> -->
            </div>
        </div>
    </div>
</div>
